var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#2D2D2D" }
    },
    [
      _c(
        "el-col",
        { staticStyle: { padding: "40px 16px" }, attrs: { span: 24 } },
        [
          _c("span", { staticClass: "stay-up-to-date-title" }, [
            _vm._v("Stay up to date")
          ])
        ]
      ),
      _vm._v(" "),
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "div-54" }, [
          _c("img", {
            staticClass: "img-8",
            attrs: {
              loading: "lazy",
              src: require("../../assets/stay-up-to-date-1.jpg")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "div-55" }, [
            _vm._v("The features renters want most")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "div-56" }, [
            _c("div", { staticClass: "div-57" }, [_vm._v("Read more")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-9",
              attrs: {
                loading: "lazy",
                src: require("../../assets/Chevrons.svg")
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "div-54" }, [
          _c("img", {
            staticClass: "img-8",
            attrs: {
              loading: "lazy",
              src: require("../../assets/stay-up-to-date-2.jpg")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "div-55" }, [
            _vm._v("What does RBA price rises mean for you?")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "div-56" }, [
            _c("div", { staticClass: "div-57" }, [_vm._v("Read more")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-9",
              attrs: {
                loading: "lazy",
                src: require("../../assets/Chevrons.svg")
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "div-54" }, [
          _c("img", {
            staticClass: "img-8",
            attrs: {
              loading: "lazy",
              src: require("../../assets/stay-up-to-date-3.jpg")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "div-55" }, [
            _vm._v("How to pick the right agent")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "div-56" }, [
            _c("div", { staticClass: "div-57" }, [_vm._v("Read more")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-9",
              attrs: {
                loading: "lazy",
                src: require("../../assets/Chevrons.svg")
              }
            })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8582a614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8582a614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/stayUpToDate.vue
// module id = null
// module chunks = 